<template>
  <div class="app-container">
    <div class="title-row"><span class="title">{{ this.$route.meta.title }}</span></div>
    <!-- 文章标题 -->
    <div class="article-title-container">
      <el-input
        v-model="article.articleTitle"
        placeholder="输入文章标题"
      />
      <el-button
        v-hasPermi="['article:manage:edit']"
        type="danger"
        class="save-btn"
        @click="saveArticleDraft"
        v-if="article.isDraft != 0"
      >
        保存草稿
      </el-button>
      <el-button
        v-hasPermi="['article:manage:edit']"
        type="danger"
        @click="publishOpen = true"
        style="margin-left:10px"
      >
        发布文章
      </el-button>
    </div>
    <!-- 文章内容 -->
    <mavon-editor
      ref="md"
      v-model="article.articleContent"
      @imgAdd="uploadImg"
      style="height:calc(100vh - 265px)"
    />
    <!-- 发布文章对话框 -->
    <el-dialog title="发布文章" :visible.sync="publishOpen" width="40%" top="10vh" :close-on-click-modal="false" >
      <!-- 文章数据 -->
      <el-form label-width="80px" :model="article">
        <el-form-item label="文章分类">
          <el-select v-model="article.categoryId" placeholder="请选择分类">
            <el-option
              v-for="item in categoryList"
              :key="item.categoryId"
              :label="item.categoryName"
              :value="item.categoryId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="文章标签">
          <el-select
            v-model="article.tagIdList"
            multiple
            placeholder="请选择标签"
          >
            <el-option
              v-for="item in tagList"
              :key="item.tagId"
              :label="item.tagName"
              :value="item.tagId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="上传封面" prop="articleCover">
          <image-upload v-model="article.articleCover" :limit="1" action="/admin/articles/images">
          </image-upload>
        </el-form-item>
        <el-form-item label="置顶">
          <el-switch
            v-model="article.isTop"
            active-color="#13ce66"
            inactive-color="#F4F4F5"
            :active-value="1"
            :inactive-value="0"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="publishOpen = false">取 消</el-button>
        <el-button type="danger" @click="saveOrUpdateArticle">
          发 表
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getArticleInfo,
  getArticleOptions,
  addArticle,
  updateArticle,
  uploadImg
} from "@/api/article/article";
import {getToken} from "@/utils/auth";

export default {
  data: function() {
    return {
      publishOpen: false,
      autoSave: true,
      categoryList: [],
      tagList: [],


      article: {
        articleId: null,
        articleTitle: this.parseTime(new Date(),"YYYY-MM-DD"),
        articleContent: "",
        articleCover: "",
        categoryId: null,
        tagIdList: [],
        isTop: 0,
        isDraft: null
      },
      headers: {
        Authorization: 'Bearer ' + getToken()
      },
    };
  },
  created() {
    const articleId = this.$route.query && this.$route.query.articleId
    if (articleId) {
      getArticleInfo(articleId).then(response => {
        this.article = response.data;
      });
    }
    this.listArticleOptions();
  },
  destroyed() {
    //文章自动保存功能
    this.autoSaveArticle();
  },
  methods: {
    listArticleOptions() {
      getArticleOptions().then(response => {
        this.categoryList = response.data.categoryDTOList;
        this.tagList = response.data.tagDTOList;
      });
    },
    uploadImg(pos, file) {
      var formdata = new FormData();
      formdata.append("file", file);
      uploadImg(formdata).then(res => {
        this.$refs.md.$img2Url(pos, res.fileName);
      });
    },
    /** 保存草稿 */
    saveArticleDraft() {
      if (this.article.articleTitle.trim() === "") {
        this.$modal.msgError("文章标题不能为空");
        return false;
      }
      if (this.article.articleContent.trim() === "") {
        this.$modal.msgError("文章内容不能为空");
        return false;
      }
      this.article.isDraft = 1;
      if (this.article.articleId!=null) {
        updateArticle(this.article).then(res => {
          if (res.flag) {
            this.article.articleId=res.data;
            this.$modal.msgSuccess("编辑草稿成功");
          } else {
            this.$modal.msgError("编辑草稿失败");
          }
        });
      }else{
        addArticle(this.article).then(res => {
          if (res.flag) {
            this.article.articleId=res.data;
            this.$modal.msgSuccess("创建草稿成功");
          } else {
            this.$modal.msgError("创建草稿失败");
          }
        });
      }

      //关闭自动保存功能
      this.autoSave = false;
    },
    saveOrUpdateArticle() {
      if (this.article.articleTitle.trim() === "") {
        this.$modal.msgError("文章标题不能为空");
        return false;
      }
      if (this.article.articleContent.trim() === "") {
        this.$modal.msgError("文章内容不能为空");
        return false;
      }
      if (!this.article.categoryId) {
        this.$modal.msgError("文章分类不能为空");
        return false;
      }
      if (this.article.tagIdList.length === 0) {
        this.$modal.msgError("文章标签不能为空");
        return false;
      }
      if (this.article.articleCover.trim() === "") {
        this.$modal.msgError("文章封面不能为空");
        return false;
      }
      this.article.isDraft = 0;
      if (this.article.articleId!=null) {
        updateArticle(this.article).then(res => {
          if (res.flag) {
            this.article.articleId = res.data;
            this.$modal.msgSuccess("文章发布成功");
          } else {
            this.$modal.msgError("文章发布失败");
          }
          this.publishOpen = false;
        });
      }else{
        addArticle(this.article).then(res => {
          if (res.flag) {
            this.article.articleId = res.data;
            this.$modal.msgSuccess("文章发布成功");
          } else {
            this.$modal.msgError("文章发布失败");
          }
          this.publishOpen = false;
        });
      }
      //关闭自动保存功能
      this.autoSave = false;
    },
    autoSaveArticle() {
      if (this.autoSave && this.article.articleTitle.trim() !== "" && this.article.articleContent.trim() !== "") {
        this.article.isDraft = this.article.isDraft == 0 ? this.article.isDraft : 1;
        if (this.article.articleId!=null) {
          updateArticle(this.article).then(res => {
            if (res.flag) {
              this.article.articleId = res.data;
              this.$modal.msgSuccess("自动保存成功");
            } else {
              this.$modal.msgError("自动保存失败");
            }
          });
        }else{
          addArticle(this.article).then(res => {
            if (res.flag) {
              this.article.articleId = res.data;
              this.$modal.msgSuccess("自动保存成功");
            } else {
              this.$modal.msgError("自动保存失败");
            }
          });
        }
      }
    }
  }
};
</script>

<style scoped>
.article-title-container {
  display: flex;
  align-items: center;
  margin-bottom: 1.25rem;
}
.save-btn {
  margin-left: 0.75rem;
  background: #fff;
  color: #f56c6c;
}
</style>
